function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { VuetifyWidgetModel } from './VuetifyWidget';
export class ContentModel extends VuetifyWidgetModel {
  defaults() {
    return _objectSpread({}, super.defaults(), {
      _model_name: 'ContentModel',
      tag: null,
      mt_auto: null,
      mt_0: null,
      mt_1: null,
      mt_2: null,
      mt_3: null,
      mt_4: null,
      mt_5: null,
      mb_auto: null,
      mb_0: null,
      mb_1: null,
      mb_2: null,
      mb_3: null,
      mb_4: null,
      mb_5: null,
      ml_auto: null,
      ml_0: null,
      ml_1: null,
      ml_2: null,
      ml_3: null,
      ml_4: null,
      ml_5: null,
      mr_auto: null,
      mr_0: null,
      mr_1: null,
      mr_2: null,
      mr_3: null,
      mr_4: null,
      mr_5: null,
      mx_auto: null,
      mx_0: null,
      mx_1: null,
      mx_2: null,
      mx_3: null,
      mx_4: null,
      mx_5: null,
      my_auto: null,
      my_0: null,
      my_1: null,
      my_2: null,
      my_3: null,
      my_4: null,
      my_5: null,
      ma_auto: null,
      ma_0: null,
      ma_1: null,
      ma_2: null,
      ma_3: null,
      ma_4: null,
      ma_5: null,
      pt_auto: null,
      pt_0: null,
      pt_1: null,
      pt_2: null,
      pt_3: null,
      pt_4: null,
      pt_5: null,
      pb_auto: null,
      pb_0: null,
      pb_1: null,
      pb_2: null,
      pb_3: null,
      pb_4: null,
      pb_5: null,
      pl_auto: null,
      pl_0: null,
      pl_1: null,
      pl_2: null,
      pl_3: null,
      pl_4: null,
      pl_5: null,
      pr_auto: null,
      pr_0: null,
      pr_1: null,
      pr_2: null,
      pr_3: null,
      pr_4: null,
      pr_5: null,
      px_auto: null,
      px_0: null,
      px_1: null,
      px_2: null,
      px_3: null,
      px_4: null,
      px_5: null,
      py_auto: null,
      py_0: null,
      py_1: null,
      py_2: null,
      py_3: null,
      py_4: null,
      py_5: null,
      pa_auto: null,
      pa_0: null,
      pa_1: null,
      pa_2: null,
      pa_3: null,
      pa_4: null,
      pa_5: null
    });
  }

  getVueTag() {
    // eslint-disable-line class-methods-use-this
    return 'v-content';
  }

}
ContentModel.serializers = _objectSpread({}, VuetifyWidgetModel.serializers);